import { z } from 'zod';

import { OnboardingImportTenantIdsSchema } from '../client-context/onboarding-import.js';

// ─── Sync Event Payloads ────────────────────────────────────────────
// Zod schemas for data-sync domain events.

/** Trigger-only event — requests a full sync of all upstream data. */
export const SyncAllRequestedPayload = z.object({});

export type SyncAllRequestedPayload = z.infer<typeof SyncAllRequestedPayload>;

/** Requests KPI precache refresh for a single tenant (default filter snapshots). */
export const TenantKpiPrecacheRequestedPayload = z.object({
  tenantId: z.string().cuid2(),
});

export type TenantKpiPrecacheRequestedPayload = z.infer<typeof TenantKpiPrecacheRequestedPayload>;

/**
 * Admin → Settings → System, "Import onboarding data from BQ": refreshes the selected tenants' Nexus
 * onboarding records from the onboarding BigQuery tables. The worker resolves each customer from
 * the tenant's own customerPartition, so the payload carries no names. Never empty: "all" is an
 * explicit list of every eligible tenant.
 */
export const TenantOnboardingSyncRequestedPayload = z
  .object({
    tenantIds: OnboardingImportTenantIdsSchema,
  })
  .strict();

export type TenantOnboardingSyncRequestedPayload = z.infer<typeof TenantOnboardingSyncRequestedPayload>;
